import { reactive } from 'vue'
import { useUserStore } from './useUserStore'
import { version } from '../../package.json'
import { useGlobalLoading } from './useGlobalLoading'
import { addBreadcrumb, captureError } from '@/utils'

// 应用配置类型
export interface AppConfig {
  title: string
  version: string
  apiBaseUrl: string
  enableDebug: boolean
}

// 全局应用状态
const appState = reactive<{
  config: AppConfig
  hasInitError: boolean
  hasInit: boolean
}>({
  config: {
    title: '搜狐云-Panther',
    version,
    apiBaseUrl: '/api/v1',
    enableDebug: import.meta.env.MODE === 'development'
  },
  hasInitError: false,
  hasInit: false
})

export function useAppStore() {
  // === 基础应用方法 ===
  // 初始化应用
  // 获取用户信息（建立认证态）
  const userStore = useUserStore()
  const { show, hide } = useGlobalLoading()
  const initApp = async () => {
    try {
      show()
      appState.hasInitError = false
      await userStore.fetchUserInfo()
    } catch (error) {
      addBreadcrumb({
        message: '应用初始化失败',
        category: 'app/init',
        level: 'error'
      })
      if (error instanceof Error) {
        captureError(error, {
          feature: 'app-init'
        })
      }
      // 开发环境先设置为false，方便调试
      if (import.meta.env.MODE === 'development') {
        appState.hasInitError = false
      } else {
        appState.hasInitError = true
      }
    } finally {
      hide()
      appState.hasInit = true
    }
  }

  // 清理应用
  const cleanupApp = () => {}

  return {
    appState,

    // === 基础应用方法 ===
    initApp,
    cleanupApp
  }
}
